import { createSelector } from 'reselect'
import getValueReduxUtil from 'modules/redux/utils/get-value/index.js'
import {
  getCurrentWorkoutSelect,
  WORKOUT_KEY
} from '@gymaholic/packages'

const getStartedCountWorkoutSelect = createSelector(
  getCurrentWorkoutSelect,
  (value) => {
    return (
      getValueReduxUtil(value, WORKOUT_KEY.STARTED_COUNT) || 0
    )
  }
)

export default getStartedCountWorkoutSelect
